<template>
  <div class="blog-container" :style="{ backgroundImage: patternIizenglish }">
    <StaticPagesHeader class="header"></StaticPagesHeader>
    <section class="container">
      <div class="latest-blog-item" v-if="blogs.length > 0">
        <h2 class="blog-latest">{{ $t(`message.blogs.latest`) }}</h2>
        <div
          v-for="(blog, index) in latestPublishedBlogs"
          :key="blog.id"
          class="blog-title text-break"
        >
          <a
            :href="'#blog-' + blog.id"
            @click.prevent="scrollToBlog('blog-' + blog.id)"
          >
            {{ index + 1 }}.
            {{
              selectedLocale in blog.contents
                ? blog.contents[selectedLocale].title
                : blog.contents[$store.getters["locales/getDefaultLocale"].code]
                    .title
            }}
          </a>
        </div>
      </div>
      <div class="title-container">
        <h1 class="title">{{ $t(`message.talkingAboutUs`) }}</h1>
      </div>
      <span v-for="blog in blogs" :key="blog.id" :id="'blog-' + blog.id">
        <blog-item :blog="blog" />
      </span>
      <div v-if="isLoadingBlogs" class="spinner-container">
        <div class="spinner"></div>
      </div>
      <div v-else-if="blogs.length === 0" class="text-center">
        <h5>{{ this.$t(`message.blogs.emptyPage`) }}</h5>
      </div>
      <div v-else-if="showLoadMoreButton" class="d-flex justify-content-center">
        <button class="display-more" @click="loadMorePublishedBlogs">
          {{ $t(`message.blogs.seeMore`) }}
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import PatternIizenglishHomeMultisupport from "@/assets/homepage/pattern-iizenglish-home-multisupport.webp";
import StaticPagesHeader from "@/components/staticpages/StaticPagesHeader";
import { mapActions, mapGetters } from "vuex";
import BlogItem from "@/components/blog/BlogItem";

export default {
  name: "BlogPostsAboutUs",
  components: {
    StaticPagesHeader,
    BlogItem,
  },
  data() {
    return {
      patternIizenglish: `url(${PatternIizenglishHomeMultisupport})`,
      isLoadingBlogs: false,
      locales: this.$store.getters["locales/getLocales"],
      showLoadMoreButton: true,
    };
  },
  computed: {
    ...mapGetters("blog", ["getBlogs", "getTotalItems"]),
    pageNumber() {
      var value = 0;
      if (this.blogs.length > 0) {
        value = Math.ceil(this.blogs.length / 5);
      }
      return value;
    },
    blogs() {
      return this.getBlogs;
    },
    latestPublishedBlogs() {
      return this.getBlogs.slice(0, 5);
    },
    totalItems() {
      return this.getTotalItems;
    },
    selectedLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    ...mapActions("blog", ["getPublishedBlogs"]),
    loadMorePublishedBlogs() {
      const pageNumber = this.pageNumber + 1;

      this.getPublishedBlogs({ pageNumber, append: true })
        .then(() => {
          if (this.blogs.length >= this.getTotalItems) {
            this.showLoadMoreButton = false;
          }
        })
        .catch(() => {
          console.error("Error fetching published blogs.");
        })
        .finally(() => {
          this.isLoadingBlogs = false;
        });
    },
    scrollToBlog(blogId) {
      const element = document.getElementById(blogId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    handleScroll() {
      const scrollDistance = window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;
      if (
        !this.isLoadingBlogs &&
        scrollDistance + windowHeight >= pageHeight &&
        this.blogs.length < this.getTotalItems
      ) {
        this.loadMorePublishedBlogs();
      }
    },
  },
  created() {
    this.isLoadingBlogs = true;

    this.getPublishedBlogs({
      pageNumber: this.pageNumber + 1,
      append: false,
    })
      .catch(() => {
        console.error("Error fetching published blogs.");
      })
      .finally(() => {
        this.isLoadingBlogs = false;
      });
  },
};
</script>

<style scoped lang="scss">
.accordion-button:after {
  background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>") !important;
}

.blog-container {
  min-height: 93vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-color: $whiteColor;
  box-shadow: inset 0 0 0 1000px rgba(255, 255, 255, 0.8);
  position: relative;

  .spinner-container {
    text-align: center;
    padding: 20px;
  }

  .spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: $secondaryColor;
    animation: spin 1s linear infinite;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: inline-block;
  }

  .display-more {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 200px;
    border: 3px solid $secondaryColor;
    background-color: $secondaryColor;
    color: $whiteColor;
    height: 40px;
    border-radius: 20px;
    margin-bottom: 30px;

    &:hover {
      cursor: pointer;
      color: $secondaryColor;
      background-color: $whiteColor;
    }
  }

  .latest-blog-item {
    position: absolute;
    background-color: white;
    border: 2px solid $secondaryColor;
    padding: 10px;
    margin-top: 10px;
    border-radius: 10px;
    right: 20px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    li {
      width: 50%;
    }

    @media (min-width: 1100px) {
      width: 30%;
    }
  }
  .blog-title {
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    color: $primaryColor;
    font-weight: 700;
    font-family: "Averia Sans Libre", sans-serif;
    a {
      color: $primaryColor;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .blog-latest {
    text-align: center;
    color: $primaryColor;
    font-weight: 700;
    font-family: "Averia Sans Libre", sans-serif;
  }
  .title-container {
    margin-top: 20px;
    text-align: center;
    color: $primaryColor;
    margin-bottom: 80px;
    width: 100%;
    display: flex;
    justify-content: center;

    .title {
      font-size: 3em;
      font-family: "Averia Sans Libre", sans-serif;
      margin: 40px 0 40px 0;
      max-width: 50%;
    }
  }
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  @media screen and (max-width: 1104px) {
    .latest-blog-item {
      margin-top: 50px;
      display: block;
      position: initial;
    }
    .title {
      margin-bottom: 50px;
    }
  }
}
</style>
